import { filterPrescriptionStatus } from '../constant/constant';
import { ROLE, PrescriptionStatus } from '../interface/interface';

export const generateOptions = (userRole?: string) => {
  const adminRoles = [ROLE.Admin, ROLE.Pharmacist, ROLE.Doctors];
  const limitedRoles = [ROLE.Patients, ROLE.PLO, ROLE.Dispense_Tech];

  if (adminRoles.includes(userRole as ROLE)) {
    return [{ label: 'All', value: 'all' }, ...filterPrescriptionStatus];
  }

  if (limitedRoles.includes(userRole as ROLE)) {
    return filterPrescriptionStatus.filter(
      (x) => x.value === PrescriptionStatus.Active,
    );
  }

  return [
    { label: 'All', value: 'all' },
    ...filterPrescriptionStatus.filter(
      (x) =>
        ![PrescriptionStatus.Stopped, PrescriptionStatus.Cancelled].includes(
          x.value as PrescriptionStatus,
        ),
    ),
  ];
};
